export default __webpack_public_path__ + "static/media/black_royal_queen.e0f6fa7e.png";